/**
 * Blank Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('PentestTasksBlankController', [
        '$scope',
        '$window',
        '$timeout',    
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.mapList = function(list) {
                var res = {};
                
                for (var el of list) {
                    res[el] = true;
                }
                
                return res;
            };
            
            $scope.unmapList = function(list) {
                var res = [];
                for (var el in list) {
                    if (list[el]) {
                        res.push(el);
                    }
                }
                
                return res;
            };
            
            $scope.task = {
                orig_task_id: task_id ? task_id : '',
                task_id: task.task_id ? task.task_id : '',
                title: task.title ? task.title : '',   
                task_user_ids: task_user_ids ? task_user_ids : [],
            };                                    
            
            $scope.upsertTask = function() {                                                                                                 
                
                showModalDialog('Please confirm that you are going to save task '+ $scope.task.task_id, function() {
                    var data = {...$scope.task};                    
                    
                    $('#loader').parent().show();
                    $('#loader').show();
                    
                    seApi.upsert("pentestTasks", JSON.stringify(data)).then(
                        function(data) {                                                        
                            $.alert('success', 'message' in data ? data.message : 'Task was successfully saved', true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                            
                            $window.setTimeout(
                                function() {
                                    $window.location.href = '/#!/se/pentestTasks';
                                }, 
                                1500
                            );                          
                        },
                        function(data) {                                                        
                            let error = 'message' in data ? ': '+data.message : '';
                            $.alert('error', 'Error occured'+error, false);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        }
                    );
                });                 
            };
        }
    ]);
})(window.angular);
